var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "10088 688 22 20.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-4 {\n        fill: #2400ff;\n      }\n\n      .cls-2 {\n        fill: none;\n        opacity: 0.64;\n      }\n\n      .cls-3, .cls-4 {\n        stroke: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277",
    transform: "translate(8873 178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M38.367,36.828h2.912a1.437,1.437,0,0,1,1.333.947H38.367v1.263h4.246a1.437,1.437,0,0,1-1.333.947H37.7l5.579,5.93L44.156,45l-3.509-3.719h.7a2.8,2.8,0,0,0,2.6-2.211H45.7V37.811H43.946a2.836,2.836,0,0,0-.386-.947H45.7V35.6H38.367Z",
    transform: "translate(1183.883 480.4)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-2",
    transform: "translate(1215 510)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.5,0h11A5.5,5.5,0,0,1,22,5.5v9.9a5.5,5.5,0,0,1-5.5,5.5H5.5A5.5,5.5,0,0,1,0,15.4V5.5A5.5,5.5,0,0,1,5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 16.5 19.89999961853027 C 18.98130989074707 19.89999961853027 21 17.88130950927734 21 15.39999961853027 L 21 5.5 C 21 3.018689870834351 18.98130989074707 0.9999998211860657 16.5 0.9999998211860657 L 5.5 0.9999998211860657 C 3.01869010925293 0.9999998211860657 1 3.018689870834351 1 5.5 L 1 15.39999961853027 C 1 17.88130950927734 3.01869010925293 19.89999961853027 5.5 19.89999961853027 L 16.5 19.89999961853027 M 16.5 20.89999961853027 L 5.5 20.89999961853027 C 2.462430000305176 20.89999961853027 -1.77635683940025e-15 18.43757057189941 -1.77635683940025e-15 15.39999961853027 L -1.77635683940025e-15 5.5 C -1.77635683940025e-15 2.462429761886597 2.462430000305176 -1.907348661234209e-07 5.5 -1.907348661234209e-07 L 16.5 -1.907348661234209e-07 C 19.53757095336914 -1.907348661234209e-07 22 2.462429761886597 22 5.5 L 22 15.39999961853027 C 22 18.43757057189941 19.53757095336914 20.89999961853027 16.5 20.89999961853027 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupees);
export default __webpack_public_path__ + "static/media/rupees.922e570bc4428153262704b808c8b7e9.svg";
export { ForwardRef as ReactComponent };